'use strict';

var titles = require('../../../../../../../../../_virtual/titles.cjs');
var typography = require('../typography.cjs');

var hasRequiredTitles;

function requireTitles () {
	if (hasRequiredTitles) return titles.__exports;
	hasRequiredTitles = 1;

	var typography$1 = typography.__require();

	const ChromaticTitleSize = typography$1.TYPOGRAPHY_TYPES.h2;

	titles.__exports.ChromaticTitleSize = ChromaticTitleSize;
	
	return titles.__exports;
}

exports.__require = requireTitles;
//# sourceMappingURL=titles.cjs.map
